import React from 'react';
import {useCallback, useRef, useState} from 'react';

/**
 * @deprecated this should be phased out as it's not a good pattern to use (i am sorry)
 */
export function useRefState<S>(
	initialValue: S | (() => S),
): [S, React.MutableRefObject<S>, React.Dispatch<React.SetStateAction<S>>] {
	const [state, setState] = useState(initialValue);
	const stateRef = useRef(state);

	const _setState = useCallback((value: S | ((state: S) => S)) => {
		setState((state: S) => {
			const newState =
				typeof value === 'function' ? (value as Function)(state) : value;
			stateRef.current = newState;
			return newState;
		});
	}, []);

	return [state, stateRef, _setState];
}

export default useRefState;
